export const normalizeSeoText = (value = '') => `${value}`
    .replace(/\[([^\]]+)\]\([^)]+\)/g, '$1')
    .replace(/\(\s*([A-Za-z0-9]{1,}\.[^)]*)\s*\)/g, '$1')
    .replace(/<[^>]+>/g, ' ')
    .replace(/\s+/g, ' ')
    .replace(/\s+([,.;:!?])/g, '$1')
    .trim();

export const truncateSeoText = (value = '', maxLength = 160) => {
    const normalized = normalizeSeoText(value);
    if (normalized.length <= maxLength) return normalized;
    return `${normalized.slice(0, maxLength - 1).trimEnd()}…`;
};

export const buildEntitySeoTitle = ({
    type,
    name,
    summary,
    crossReferenceCount,
    mapAvailable = false,
}) => {
    const normalizedSummary = normalizeSeoText(summary);
    const hasSummary = normalizedSummary.length > 0;
    const hasReferences = Number.isFinite(crossReferenceCount) && crossReferenceCount > 0;

    if (type === 'person') {
        if (hasSummary) return `${name} in the Bible: Meaning, Story & Verses | ai-BIBLE`;
        if (hasReferences) return `${name} in the Bible: Verses, Meaning & Context | ai-BIBLE`;
        return `${name} in the Bible | ai-BIBLE`;
    }

    if (type === 'place') {
        if (mapAvailable && hasSummary) return `${name} in the Bible: Location, Map & Meaning | ai-BIBLE`;
        if (mapAvailable && hasReferences) return `${name} in the Bible: Location Map & Verses | ai-BIBLE`;
        if (hasSummary) return `${name} in the Bible: Location, Meaning & Verses | ai-BIBLE`;
        if (hasReferences) return `${name} in the Bible: Location & Bible References | ai-BIBLE`;
        return `${name} in the Bible | ai-BIBLE`;
    }

    return `${name} in the Bible | ai-BIBLE`;
};

export const buildEntitySeoDescription = ({
    type,
    name,
    summary,
    crossReferenceCount,
    mapAvailable = false,
}) => {
    const intro = type === 'place'
        ? `Explore ${name} in the Bible`
        : `Discover ${name} in the Bible`;
    const referenceText = crossReferenceCount > 0
        ? ` Explore ${crossReferenceCount} Bible reference${crossReferenceCount === 1 ? '' : 's'}, context, and related insights on ai-BIBLE.`
        : ' Explore the key Bible references and context on ai-BIBLE.';

    if (summary) {
        if (type === 'place') {
            const mapText = mapAvailable
                ? ' View the location map and biblical context on ai-BIBLE.'
                : '';
            return truncateSeoText(`${summary}${referenceText}${mapText}`);
        }
        return truncateSeoText(`${intro}. ${summary}${referenceText}`);
    }

    if (type === 'place') {
        if (mapAvailable) {
            return truncateSeoText(`${name} in the Bible with location map, meaning, and key Bible references on ai-BIBLE.`);
        }
        return truncateSeoText(`${name} in the Bible with location, meaning, and key Bible references on ai-BIBLE.`);
    }

    return truncateSeoText(`${intro} with meaning, story, and key Bible references on ai-BIBLE.`);
};

export const buildBookSeoDescription = ({
    name,
    summary,
    author,
    concerns,
}) => {
    const parts = [
        `Explore ${name} with chapter outlines, key themes, and direct reading links on ai-BIBLE.`,
        summary ? summary : '',
        author ? `Traditionally attributed to ${author}.` : '',
        concerns ? `Often dated around ${concerns}.` : '',
    ].filter(Boolean);

    return truncateSeoText(parts.join(' '));
};

export const buildBookSeoTitle = ({
    name,
    summary,
}) => {
    const normalizedSummary = normalizeSeoText(summary);

    if (normalizedSummary) {
        return `${name} Overview: Themes, Outline & Chapter Guide | ai-BIBLE`;
    }

    return `${name}: Outline & Chapter Guide | ai-BIBLE`;
};
